import { startTest } from '../../test/util.js';
import './littleDropDownSpec.js';

startTest();
